import { useSelector } from 'react-redux';
import { selectBreakpoint, selectIsDiscord, selectIsMobile } from '../selectors/app';
import { isLarge } from './breakpoints';
import { useShouldShowPlayer } from './playerStatus/shouldShowPlayer';

// On Web Desktop at or abov the Large breakpoint, the app toast should render in the Player component so that it can
// appear centered above the play button.
export function showAppToastInPlayer(reduxState, shouldShowPlayer) {
  return (
    !selectIsMobile(reduxState) &&
    !selectIsDiscord(reduxState) &&
    shouldShowPlayer &&
    isLarge(selectBreakpoint(reduxState))
  );
}

export function useShowAppToastInPlayer() {
  const reduxState = useSelector((state) => state);
  const shouldShowPlayer = useShouldShowPlayer();

  return showAppToastInPlayer(reduxState, shouldShowPlayer);
}
